module.exports = __webpack_public_path__ + "media/index.3da302c1.mp4";